import { Box, Chip } from "@mui/joy";
import { CloseIcon } from "../../styles/StyledMUI";
import IconButtonCTA from "./IconButtonCTA";
import { colorTokens, withAlpha } from "../../styles/globalStyles";

type ActiveAlertChipProps = {
  alertName: string;
  onClear: () => void;
};

const chipCloseButtonSx = {
  minWidth: "20px",
  minHeight: "20px",
  p: 0.25,
  zIndex: 10,
  cursor: "pointer",
  "&:hover": { backgroundColor: withAlpha(colorTokens.text.primary, 0.1) },
};

export default function ActiveAlertChip({ alertName, onClear }: ActiveAlertChipProps) {
  if (!alertName) return null;

  return (
    <Chip
      variant="soft"
      color="warning"
      endDecorator={
        <IconButtonCTA
          ctaVariant="neutral"
          aria-label="Retirer alerte active"
          size="sm"
          variant="plain"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClear();
          }}
          sx={chipCloseButtonSx}
        >
          <CloseIcon sx={{ fontSize: "14px" }} />
        </IconButtonCTA>
      }
      sx={{ maxWidth: 360, "& .MuiChip-endDecorator": { pointerEvents: "auto" } }}
    >
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          pointerEvents: "none",
        }}
      >
        Alerte: {alertName}
      </Box>
    </Chip>
  );
}
